import {END, eventChannel} from 'redux-saga';

export function periodicEventChannel(timeout) {
    let counter = 0;
    return eventChannel((emitter) => {
        const id = setInterval(() => {
            counter++;
            emitter(counter);
        }, timeout);
        return () => clearInterval(id);
    });
}

export function setterChannel(setter) {
    let closed = false;
    return {
        take(callback) {
            if (closed) {
                callback(END);
            }
        },
        put(message) {
            if (!closed) {
                setter(message);
            }
        },
        flush(callback) {
            if (closed) {
                callback(END);
            }
        },
        close() {
            if (!closed) {
                closed = true;
                setter(END);
            }
        }
    };
}
